export default __webpack_public_path__ + "static/media/element_96.b4df51ba.webp";